const filterNetworkSpecificAddresses = (addresses, selectedBlockain) =>
    addresses
        .filter(address => address.blockchain == selectedBlockain)
        .map(address => {
            const addressLength = address.address.length;
            const visibleStart = 20;
            const visibleEnd = 4;

            const shortenedAddress =
                addressLength > visibleStart + visibleEnd
                    ? address.address.slice(0, visibleStart) +
                      '...' +
                      address.address.slice(addressLength - visibleEnd)
                    : address.address;

            return {
                currencyShortName: `${address.nickName}: ${shortenedAddress}`,
                address: address.address,
                name: address.nickName,
            };
        });

export { filterNetworkSpecificAddresses };
